"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREDIT_CARD_FILTER_ICON_MAP = void 0;
var CREDIT_CARD_FILTER_ICON_MAP = {
  '0% apr': 'https://assets.nav.com/design-assets/icons/logged-out/System/zeroPercent.svg',
  'balance transfer': 'https://assets.nav.com/design-assets/icons/logged-out/System/balanceTransfer.svg',
  'best credit cards': 'https://assets.nav.com/design-assets/icons/logged-out/System/badgeWithStar.svg',
  'cash back': 'https://assets.nav.com/design-assets/icons/logged-out/System/moneyHand.svg',
  'charge card': 'https://assets.nav.com/design-assets/icons/logged-out/System/lightningBolt.svg',
  'credit range': 'https://assets.nav.com/design-assets/icons/dashboard.svg',
  'financial institution': 'https://assets.nav.com/design-assets/icons/logged-out/System/bank.svg',
  'low apr': 'https://assets.nav.com/design-assets/icons/logged-out/System/percentInCircle.svg',
  miles: 'https://assets.nav.com/design-assets/icons/logged-out/System/plane.svg',
  'no annual fee': 'https://assets.nav.com/design-assets/icons/logged-out/System/noCalendar.svg',
  'no foreign transaction fee': 'https://assets.nav.com/design-assets/icons/logged-out/System/noForeign.svg',
  points: 'https://assets.nav.com/design-assets/icons/logged-out/System/piggyBankHeart.svg',
  rewards: 'https://assets.nav.com/design-assets/icons/logged-out/System/gift.svg',
  'sign up bonus': 'https://assets.nav.com/design-assets/icons/logged-out/System/moneyStack.svg'
};
exports.CREDIT_CARD_FILTER_ICON_MAP = CREDIT_CARD_FILTER_ICON_MAP;
//# sourceMappingURL=icons.js.map